// WaitForConfirmation.tsx
import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Container, Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore3';
import OnboardingForm from '../custom/setup/OnboardingForm';

const WaitForConfirmation: React.FC = () => {
  const { logout, resendEmail, userName, email, next, isEmailConfirmed, isLoading, error } = useAuthStore();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
  const [cooldown, setCooldown] = useState(0);
  const navigate = useNavigate();

  // Таймер для кнопки повторной отправки
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleLogoff = async () => {
    try {
      logout();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleContinue = async () => {
      useAuthStore.setState({ 
        authState: 'LOGIN', 
      });
      return;


    setMessage(null);
    await next({
      user_info: {first_name:'first_name',},
      customer_info: {legal_name: 'legal_name'},
    });
    const currentError = useAuthStore.getState().error;
    console.log('[current error in store]', currentError);
    if (currentError) {
      setMessage({type: 'error', text: currentError || 'Unknown error'});
    }
    else {
      navigate('/points');
      // window.location.href = '/points';
    }
  };

  const handleRepeat = async () => {
    setMessage(null);

    if (!email) {
      setMessage({ type: 'error', text: 'Email пользователя не найден.' });
      return;
    }

    setLoading(true);
    setMessage(null);
    try {
      const res = await resendEmail(email || '');
      if (res) {
        setMessage({ type: 'success', text: 'Письмо успешно отправлено повторно!' });
        setCooldown(60); // Блокируем кнопку на 60 секунд
      }
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || ' Ошибка при отправке. Попробуйте позже.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2, width: '100%' }}>
          <Typography variant="h5" gutterBottom fontWeight="bold">
            Подтвердите Email
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, mt: 2 }}>
            Мы отправили письмо для подтверждения email на адрес: <br />
            <strong>{email}</strong> <br />
            После подтверждения нажмите кнопку <b>«Продолжить»</b>.
          </Typography>

          {/* Сообщения об успехе/ошибке */}
          {message && (
            <Alert severity={message.type} sx={{ mb: 3, textAlign: 'left' }}>
              {message.text}
            </Alert>
          )}
          {error && (
            <Alert severity={'error'} sx={{ mb: 3, textAlign: 'left' }}>
              {error}
            </Alert>
          )}

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mb: 4 }}>
            <Button variant="outlined" color="error" onClick={handleLogoff} sx={{ flex: 1 }}>
              Logoff
            </Button>
            <Button variant="contained" color="primary" onClick={handleContinue} sx={{ flex: 1 }}>
              Продолжить
            </Button>
          </Box>

          <hr style={{ border: '0', borderTop: '1px solid #eee', marginBottom: '24px' }} />

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Не пришло письмо? Проверьте папку «Спам» или нажмите кнопку ниже.
          </Typography>

          <Button 
            variant="outlined" 
            color="secondary" 
            onClick={handleRepeat} 
            disabled={loading || cooldown > 0}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            sx={{ minWidth: '200px' }}
          >
            {cooldown > 0 ? `Повторить через ${cooldown}с` : 'Отправить повторно'}
          </Button>

        </Paper>
      </Box>
    </Container>
  );
};

export default WaitForConfirmation;